import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ index, label, dark = false }) => (
  <Reveal
    className={`mb-10 flex items-center gap-4 font-mono text-[11px] uppercase tracking-[0.3em] ${
      dark ? "text-white/45" : "text-ink/45"
    }`}
  >
    <span className={dark ? "text-accent" : "text-accent-dark"}>{index}</span>
    <span className={`h-px w-10 ${dark ? "bg-white/20" : "bg-ink/20"}`} aria-hidden="true" />
    <span>{label}</span>
  </Reveal>
);

// Fade al mount: non dipende dallo scroll né da IntersectionObserver.
// Usato dove la visibilità immediata è critica (hero mobile, pagine dirette).
export const Fade = ({ children, delay = 0, y = 24, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

// Reveal cinetico: ogni riga emerge da una maschera (hero on-load)
export const MaskedLine = ({ children, index = 0, as: Tag = "span", className = "" }) => (
  <span className="block overflow-hidden pb-[0.08em]">
    <motion.span
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.1, delay: 0.25 + index * 0.13, ease: EASE }}
      className={`block ${className}`}
    >
      <Tag className="contents">{children}</Tag>
    </motion.span>
  </span>
);
